import React, {useState} from 'react'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { GenericContainer } from '../../GlobalStyles'
import { Pad, Skill, SkillWrapper, SkillOverlay, Tool, ListTitle, SkillList, ListElement, ElementType, Dash, SkillsTitle, Strong, PrevArrowButton, NextArrowButton, SkillsPic, SkillsOverlay } from './Skills.elements';
import bg_test from "../../Images/valex.png";
import AbstractLine from '../Lines/AbstractLine';
import RightAbstractLine from "../Lines/RightAbstractLine";
import "./Fix.css";

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <NextArrowButton onClick={onClick}>Next</NextArrowButton>
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <PrevArrowButton onClick={onClick}>Back</PrevArrowButton>
    );
  }

const Skills = (props) => {

    const [current, setCurrent] = useState(0);
    var settings = {
        speed: 1000,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        afterChange: (index) => setCurrent(index),
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
            },
            {
            breakpoint: 700,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
            }
            }
        ]
      };
      
    return (
        <React.Fragment>
            <GenericContainer large>
                <AbstractLine/>
                <RightAbstractLine />
                <SkillsPic src={bg_test} />
                <SkillsOverlay />
                <SkillsTitle>Look at our <Strong>Skills</Strong></SkillsTitle>
                <Slider {...settings}>
                    {
                        props.props.Skill.map(
                            (x, i) => {
                                return (
                                    <SkillWrapper>
                                        <Pad top={i % 2 == 0 ? false : true}>
                                            <Skill src={x.BackgroundImage}>
                                                <SkillOverlay />
                                                <Tool src={x.ToolImage} />
                                            </Skill>
                                        </Pad>
                                        <Pad noanim>
                                            <ListTitle>{x.Title}</ListTitle>
                                            <SkillList>
                                                {
                                                    x.Set.Content.map(
                                                        y => {
                                                            return(
                                                                <ListElement level={y.Level}>
                                                                    <ElementType>{y.Type}</ElementType>    
                                                                    <Dash />
                                                                </ListElement>
                                                            )
                                                        }
                                                    )
                                                }

                                            </SkillList>
                                        </Pad>
                                    </SkillWrapper>
                                )
                            }
                        )
                    }
                </Slider>
            </GenericContainer>
        </React.Fragment>
    )
}

export default Skills
